import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Permissions, TreeFile, TreeFolder } from './services';
import { useControlledModal } from '../../hooks/useControlledModal';
import { FileExplorerVisualizerActions } from '../../types/fileExplorerTypes';
import { DropdownCustomToggle } from '../common/Dropdown';
import {
  DownloadIcon, EllipsisIcon, FileIcon, RenameIcon, TrashIcon,
  ViewFileIcon, FolderIcon,
} from './FileExplorerIcons';
import { RenameFileModal } from './Modals/RenameFileModal';
import { ReplaceFileModal } from './Modals/ReplaceFileModal';
import { DeleteFileModal } from './Modals/DeleteFileModal';
import { DeleteFolderModal } from './Modals/DeleteFolderModal';
import { EditFolderModal } from './Modals/EditFolderModal';

export function FileGridItemActions(
  { node, permissions, shareableLink }:
  { node: TreeFile, permissions: Permissions, shareableLink: string }) {
  const { currentAction, setCurrentAction } = useControlledModal<FileExplorerVisualizerActions>();
  const {
    can_read, can_write, can_delete, can_update,
  } = permissions;

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as={DropdownCustomToggle}
          className="file-explorer-dropdown p-3"
          id="dropdown-custom-components"
        >
          <EllipsisIcon />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {can_read && (
            <Dropdown.Item
              eventKey="file.download"
              href={node.file}
              target="_blank"
            >
              <DownloadIcon />
              Descargar
            </Dropdown.Item>
          )}
          {(can_update || can_write) && (
          <>
            <Dropdown.Item
              eventKey="file.rename"
              onClick={() => setCurrentAction('file.rename')}
            >
              <RenameIcon height={15} width={15} />
              Renombrar
            </Dropdown.Item>
            <Dropdown.Item
              eventKey="file.replace"
              onClick={() => setCurrentAction('file.replace')}
            >
              <FileIcon />
              Actualizar
            </Dropdown.Item>
          </>
          )}
          <Dropdown.Item
            eventKey="file.share"
            disabled={!shareableLink}
            onClick={() => {
              window.open(shareableLink, '_blank');
            }}
          >
            <ViewFileIcon />
            Ver documento
          </Dropdown.Item>
          {can_delete && (
            <Dropdown.Item
              eventKey="file.delete"
              onClick={() => setCurrentAction('file.delete')}
            >
              <TrashIcon />
              Eliminar
            </Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <RenameFileModal
        show={currentAction === 'file.rename'}
        onHide={() => setCurrentAction(null)}
        data={node}
      />
      <ReplaceFileModal
        show={currentAction === 'file.replace'}
        onHide={() => setCurrentAction(null)}
        data={node}
      />
      <DeleteFileModal
        show={currentAction === 'file.delete'}
        onHide={() => setCurrentAction(null)}
        data={node}
      />
    </>
  );
}

export function FolderGridItemActions({ node }: { node: TreeFolder }) {
  const { currentAction, setCurrentAction } = useControlledModal<FileExplorerVisualizerActions>();
  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          as={DropdownCustomToggle}
          className="file-explorer-dropdown p-3"
          id="dropdown-custom-components"
        >
          <EllipsisIcon />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            disabled={!node.shareable_link}
            eventKey="folder.share"
            onClick={() => {
              window.open(node.shareable_link, '_blank');
            }}
          >
            <FolderIcon />
            Ver carpeta
          </Dropdown.Item>

          <Dropdown.Item
            eventKey="folder.delete"
            onClick={() => setCurrentAction('folder.delete')}
          >
            <TrashIcon />
            Eliminar
          </Dropdown.Item>

          <Dropdown.Item
            eventKey="folder.edit"
            onClick={() => setCurrentAction('folder.edit')}
          >
            <RenameIcon />
            Editar
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <DeleteFolderModal
        show={currentAction === 'folder.delete'}
        onHide={() => setCurrentAction(null)}
        data={node}
      />
      <EditFolderModal
        show={currentAction === 'folder.edit'}
        onHide={() => setCurrentAction(null)}
        data={node}
      />
    </>
  );
}
